import React, { useEffect, useState } from "react";
import {
  Titulo,
  Container,
  Header,
  Navigator,
  Footer,
  FooterSpan,
  ContainerFixed,
  XHeader,
  ButtonMenu,
} from "./styles";
import { LogOut, Menu, X } from "react-feather";
import { CustomerLink } from "../CustomerLink";
import { useCartorio } from "../../Hooks/cartorio";
import { retiraAcentos } from "../../Services/retiraAcentos";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { usePrefeitura } from "../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";
import SinsoftLogo from "../../Assets/Sinsoft_Logo.png";
import theme from "../../Styles/theme";

export interface INavigator {
  type:
    | "PERFIL"
    | "FUNCIONÁRIOS"
    | "IMÓVEIS"
    | "PREFEITURAS"
    | "OPERAÇÕES"
    | "Cartórios"
    | "IMÓVEIS RURAIS"
    | "RELATORIOS"
    | "PESQUISAR";
  to: string;
  focus: boolean;
}

interface Props {
  titulo: string;
}

export function MenuLateral({ titulo }: Props) {
  const { signOut, cartorioIsLogged } = useCartorio();
  const { signOutPrefeitura, prefeituraIsLogged } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    signOutFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const {
    funcionarioCartorioIsLogged,
    signOutFuncionarioCartorio,
  } = useFuncionarioCartorio();

  const [navigators, setNavigators] = useState<INavigator[]>([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    if (window.location.href.indexOf("/inicio") != -1) {
      setIsMenuOpen(true);
    }
  }, [window.location.href]);
  useEffect(() => {
    if (funcionarioCartorioIsLogged)
      setNavigators([
        { to: "perfil", type: "PERFIL", focus: false },
        { to: "imoveis", type: "IMÓVEIS", focus: false },
        { to: "imoveis-rurais", type: "IMÓVEIS RURAIS", focus: false },
        { to: "operações", type: "OPERAÇÕES", focus: false },
        { to: "prefeituras", type: "PREFEITURAS", focus: false },
        { to: "pesquisar", type: "PESQUISAR", focus: false },
      ]);

    if (cartorioIsLogged)
      setNavigators([
        { to: "perfil", type: "PERFIL", focus: false },
        { to: "funcionarios", type: "FUNCIONÁRIOS", focus: false },
        { to: "imoveis", type: "IMÓVEIS", focus: false },
        { to: "imoveis-rurais", type: "IMÓVEIS RURAIS", focus: false },
        { to: "operações", type: "OPERAÇÕES", focus: false },
        { to: "prefeituras", type: "PREFEITURAS", focus: false },
        { to: "pesquisar", type: "PESQUISAR", focus: false },
      ]);

    if (prefeituraIsLogged) {
      setNavigators([
        { to: "perfil", type: "PERFIL", focus: false },
        { to: "funcionarios", type: "FUNCIONÁRIOS", focus: false },
        { to: "relatorios", type: "RELATORIOS", focus: false },
        { to: "imoveis", type: "IMÓVEIS", focus: false },
        { to: "imoveis-rurais", type: "IMÓVEIS RURAIS", focus: false },
        { to: "cartorios", type: "Cartórios", focus: false },
      ]);
    }

    if (funcionarioPrefeituraIsLogged) {
      setNavigators([
        { to: "perfil", type: "PERFIL", focus: false },
        { to: "relatorios", type: "RELATORIOS", focus: false },
        { to: "imoveis", type: "IMÓVEIS", focus: false },
        { to: "imoveis-rurais", type: "IMÓVEIS RURAIS", focus: false },
        { to: "cartorios", type: "Cartórios", focus: false },
      ]);
    }
  }, [
    funcionarioCartorioIsLogged,
    cartorioIsLogged,
    prefeituraIsLogged,
    funcionarioPrefeituraIsLogged,
  ]);

  function renderNavigator() {
    if (navigators.length > 0) {
      return navigators.map((item) => (
        <CustomerLink
          key={item.type}
          type={item.type}
          to={retiraAcentos(item.type.toLocaleLowerCase()).replaceAll(" ", "-")}
          focus={item.focus}
          // onClick={() => setIsMenuOpen(false)}
        />
      ));
    }
  }

  return isMenuOpen ? (
    <ContainerFixed>
      <Container>
        <XHeader>
          <X
            size="22px"
            style={{ cursor: "pointer" ,color:theme.colors.attention}}
            onClick={() => setIsMenuOpen(false)}
          />
        </XHeader>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center", flexDirection:"column"}}>
          <a
            href="https://sinsoft.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={SinsoftLogo}
              alt="Sinsoft Logo"
              style={{ width: "65px", height: "auto" }}
            />
          </a>
          <Titulo style={{ textAlign: "center" }}>
            Sistema de Geração de Guias de ITBI
          </Titulo>
        </div>
        <Navigator>{renderNavigator()}</Navigator>
        <Footer>
          <FooterSpan
            onClick={() => {
              if (funcionarioCartorioIsLogged) {
                signOutFuncionarioCartorio();
              }
              if (cartorioIsLogged) {
                signOut();
              }
              if (prefeituraIsLogged) {
                signOutPrefeitura();
              }
              if (funcionarioPrefeituraIsLogged) {
                signOutFuncionarioPrefeitura();
              }
            }}
          >
            SAIR
            <LogOut size={"16px"} style={{ marginLeft: "0.2vw" }} />
          </FooterSpan>
        </Footer>
      </Container>
    </ContainerFixed>
  ) : (
    <ContainerFixed>
      <ButtonMenu onClick={() => setIsMenuOpen(true)}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Menu size={34} color={theme.colors.primary} />
          <span
            style={{ marginLeft: 8, color: theme.colors.primary, fontSize: 16 }}
          >
            Menu
          </span>
        </div>
      </ButtonMenu>
    </ContainerFixed>
  );
}
